import { render, staticRenderFns } from "./WorksLoader.vue?vue&type=template&id=16e92b18&"
import script from "./WorksLoader.vue?vue&type=script&lang=js&"
export * from "./WorksLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports